import React, { Fragment, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Alert } from "reactstrap";
import { parseErrorBody } from "../../constants/utils";

const AlertError = ({ showAlertError, setShowAlertError, textHeader, textBody }) => {
  const progressBarRef = useRef(null);
  const parsedBody = parseErrorBody(textBody);
  
  useEffect(() => {
    if (showAlertError) {
      const progressBar = progressBarRef.current;
      if (progressBar) {
        progressBar.style.width = '0%';
        setTimeout(() => {
          progressBar.style.width = '100%';
        }, 10);
        
        const timer = setTimeout(() => {
          setShowAlertError(false);
        }, 5000);
        
        return () => clearTimeout(timer);
      }
    }
  }, [showAlertError, setShowAlertError]);

  if (!showAlertError) return null;
  
  return (
    <Fragment>
      <div className="floating-alert-container">
        <Alert
          className="custom-error-alert"
          isOpen={showAlertError}
          toggle={() => setShowAlertError(false)}
        >
          <div className="alert-content">
            <h5 className="alert-error-header">
              <i className="fa fa-exclamation-circle mx-2" />
              {textHeader}
            </h5>
            <div className="alert-body">
              {parsedBody}
            </div>
            <div 
              ref={progressBarRef}
              className="alert-progress-bar"
            />
          </div>
        </Alert>
      </div>
    </Fragment>
  );
};

AlertError.propTypes = {
  showAlertError: PropTypes.bool,
  setShowAlertError: PropTypes.func,
  textHeader: PropTypes.string,
  textBody: PropTypes.string,
};

export default AlertError;